<template>
  <div class="tab-list">
    <Tab
      v-for="object in objects"
      :key="object.objectId"
      class="tab-list__item"
      :text="object.name"
      :isActive="object.isActive"
      @click="() => tabClickHandler(object.objectId)"
    />
  </div>
</template>

<script>
import Tab from '@/components/shared/tabs/Tab';

export default {
  name: 'tab-list',
  components: {
    Tab,
  },
  props: {
    objects: {
      type: Array,
      required: false,
      default: [],
    },
  },
  data() {
    return {
      dataTabs: this.$props.objects,
    }
  },
  methods: {
    tabClickHandler(newActiveObjectId) {
      this.dataTabs = this.objects.map((tab) => ({
          name: tab.name,
          objectId: tab.objectId,
          isActive: newActiveObjectId === tab.objectId
        })
      )


      this.$emit('tab-click', this.dataTabs)
    },
  },
}
</script>

<style lang="scss" scoped>
.tab-list {
  display: flex;
  flex-wrap: wrap;
  gap: rem(12);
}
</style>
